import { css } from 'lit';
import componentStyles from '@manzanohq/components/dist/styles/component.styles.js';

export default [
  componentStyles,
  css`
    :host {
      display: block;
      position: relative;
      width: 100%;
    }

    .chart-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    canvas {
      display: block;
    }

    .chart-tooltip {
      position: absolute;
      pointer-events: none;
      opacity: 0;
      transition: opacity 150ms ease, transform 150ms ease;
      z-index: 10;
    }

    .chart-tooltip.visible {
      opacity: 1;
    }

    .chart-tooltip__inner {
      background: var(--mz-color-gray-900, #1c1915);
      color: var(--mz-color-gray-50, #faf9f7);
      padding: 6px 10px;
      border-radius: var(--mz-radius-md, 0.5rem);
      font-family: var(--mz-font-sans, sans-serif);
      font-size: var(--mz-font-size-xs, 0.75rem);
      line-height: 1.4;
      box-shadow: 0 4px 12px rgb(28 25 21 / 0.15);
      max-width: 200px;
    }

    .chart-tooltip__title {
      font-weight: 600;
      margin-bottom: 2px;
    }

    .chart-tooltip__item {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .chart-tooltip__swatch {
      width: 8px;
      height: 8px;
      border-radius: 2px;
      flex-shrink: 0;
    }
  `
];
